import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0.2, as: Tag = "h1", testid }) => (
  <Tag className={className} data-testid={testid}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease: [0.76, 0, 0.24, 1] }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`mb-5 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] ${light ? "text-[#b6d97a]" : "text-[#5b7a1a]"}`}>
    <span className="h-px w-10 bg-current" />
    {children}
  </p>
);
